module.exports = __webpack_public_path__ + "img/sup_deposit_vega3.f72ef5ac.jpg";